export default {
  title: 'Openingstijden',
  headers: {
    edit_time: 'Tijd bewerken',
    create_time: 'Tijd aanmaken',
  },
  labels: {
    select_all: 'Alles selecteren',
    timezone: 'Tijdzone',
  },
  fields: {
    selected_days: {
      label: 'Geselecteerde dagen',
    },
    opening_time: {
      label: 'Openingstijd',
    },
    closing_time: {
      label: 'Sluitingstijd',
    },
  },
  columns: {
    days: 'Dagen',
    time: 'Tijd',
  },
  buttons: {
    add_opening_time: 'Openingstijd toevoegen',
    add: 'Toevoegen',
    cancel: 'Annuleren',
    save: 'Opslaan',
    close: 'Sluiten',
    delete: 'Verwijderen',
    sync_from_online_shop: 'Synchroniseren vanuit Online Shop',
  },
  projects: {
    online_shop: 'Online Shop',
    reservations: 'Reserveringen',
    storefront: 'Storefront',
    not_set_up: '{{project}} (niet ingericht voor deze locatie)',
  },
  feedback: {
    missing_info: 'Ontbrekende informatie',
  },
  toasts: {
    saving_success: 'Succesvol opgeslagen',
    saving_error: 'Opslaan mislukt. Controleer uw gegevens en probeer het opnieuw.',
    sync_success: 'Succesvol gesynchroniseerd',
    sync_error: 'Synchroniseren van openingstijden vanuit online shop mislukt. Probeer het opnieuw.',
    hours_required: 'Openingstijden zijn vereist. Bewerk in plaats daarvan bestaande uren',
    not_copied: {
      reservations: {
        not_set_up:
          'Reserveringen zijn niet bijgewerkt: reserveringen zijn nog niet ingesteld voor deze locatie. Het tabblad Reserveringen legt uit waarom.',
        not_matched:
          'Reserveringen zijn niet bijgewerkt: de openingstijd {{time}} bestaat daar niet. Controleer de openingstijden in het tabblad Reserveringen.',
        failed:
          'Reserveringen konden niet worden bijgewerkt. Gebruik “Synchroniseren vanuit Online Shop” in het tabblad Reserveringen.',
      },
      storefront: {
        not_set_up: 'De Storefront is niet bijgewerkt: er is geen storefront gevonden voor deze locatie.',
        not_matched:
          'De Storefront is niet bijgewerkt: de openingstijd {{time}} bestaat daar niet. Controleer de openingstijden in het tabblad Storefront.',
        failed:
          'De Storefront kon niet worden bijgewerkt. Gebruik “Synchroniseren vanuit Online Shop” in het tabblad Storefront.',
      },
    },
  },
  modals: {
    timezone: {
      form: {
        timezone: {
          label: 'Tijdzone',
        },
      },
      toasts: {
        error: 'Tijdzone bijwerken mislukt',
      },
    },
  },
};
